module.exports = __webpack_public_path__ + "static/media/help-icon-tooltip.6eb99e82.svg";